import styled from '@emotion/styled'

import { Link } from './Link'
import { Color, theme } from '../constants'

const Root = styled.div`
  display: inline-block;
  position: relative;
  background: ${Color.DARK_BLUE};
  border-radius: ${theme.border.radius.normal}px;
  transform-style: preserve-3d;
  overflow: hidden;
`

const Grid = styled.div`
  display: inline-grid;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
`

const Active = styled.div<{ itemCount: number; selectedIndex: number }>(
  ({ itemCount, selectedIndex }) => ({
    position: 'absolute',
    inset: 0,
    width: `${100 / itemCount}%`,
    borderRadius: theme.border.radius.normal,
    background: Color.MEDIUM_BLUE,
    transform: `translateX(${100 * selectedIndex}%)`,
    transition: `transform ${theme.animation.duration}s ease-in-out`,
    zIndex: -1,
  }),
)

const ToggleGroupItem = styled.button<{
  active?: boolean
  to?: string // Added so TS doesn't complain about as={Link} to="/some-path"
}>`
  all: unset;
  text-align: center;
  box-sizing: border-box;
  padding: ${theme.spacing[1]}px ${theme.spacing[2]}px;
  background-color: transparent;
  color: ${(props) => (props.active ? Color.WHITE : Color.TRANSPARENT_BLUE)};
  transition: color ${theme.animation.duration}s ease-in-out;
  cursor: pointer;
  z-index: 1;
`

type Item = {
  label: string
  active?: boolean
  to?: string
  onClick?: () => void
}

type ToggleGroupProps = {
  items: Item[]
}

export const ToggleGroup = ({ items }: ToggleGroupProps) => {
  const selectedIndex = items.findIndex((item) => item.active)

  return (
    <Root>
      <Grid>
        {items.map((item, index) => (
          <ToggleGroupItem
            key={index}
            as={item.to ? Link : 'button'}
            active={item.active}
            to={item.to}
            onClick={item.onClick}
          >
            {item.label}
          </ToggleGroupItem>
        ))}
      </Grid>
      {selectedIndex === -1 ? null : (
        <Active itemCount={items.length} selectedIndex={selectedIndex} />
      )}
    </Root>
  )
}
